import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { FieldFilterItem, SelectedFiltersType } from 'shared/types';
import { FilterMenu } from 'shared/ui/Filter';
import { FilterColumn } from 'shared/ui/Filter/ui/FilterColumn';
import { columnConfig } from 'widgets/banner/model';
import { BannerTableItemType } from 'entities/banner/types';
import { useDeleteBannerMutation, useGetBannersQuery } from 'entities/banner';
import { useDefaultBannersTableValue } from 'widgets/banner/lib/hooks';

export const BannersTable = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { app_type } = useParams();
  const [fieldVisibility, setFieldVisibility] = useState(columnConfig.map(() => true));
  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });
  const [filter, setFilter] = useState<SelectedFiltersType>({
    appType: [],
    cities: [],
  });

  const filterField = columnConfig.filter((column, index) => fieldVisibility[index]);

  const filterFields: FieldFilterItem[] = [
    {
      title: 'Тип',
      fields: [
        { name: 'b2b', key: 'b2b', filterName: 'appType' },
        { name: 'b2c', key: 'b2c', filterName: 'appType' },
        { name: 'b2cr', key: 'b2cr', filterName: 'appType' },
      ],
    },
  ];

  const { data: bannerList } = useGetBannersQuery({
    appTypes: filter.appType && filter.appType.length > 0 ? filter.appType : null,
    page: pagination.page + 1,
    size: pagination.rowsPerPage,
  });

  const [deleteBannerRequest] = useDeleteBannerMutation();

  const dataTable = useDefaultBannersTableValue(bannerList?.items || []);

  useEffect(() => {
    if (app_type) {
      dispatch(setHeaderTitle(app_type.toUpperCase()));
    }
  }, [app_type, dispatch]);

  const handleRowClick = (id: number | string) => {
    navigate(`/content/banner/${id}`);
  };

  const handleDeleteStep = (id: number) => {
    deleteBannerRequest({ id });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <FilterMenu
          filterFields={filterFields}
          selectedFilterValues={filter}
          setFilter={setFilter}
        />
        <FilterColumn<BannerTableItemType>
          fieldVisibility={fieldVisibility}
          setFieldVisibility={setFieldVisibility}
          columnConfig={columnConfig}
        />
      </div>
      <DataTableBackendPagination
        title="Список баннеров"
        total={bannerList?.total || 0}
        pagination={pagination}
        setPagination={setPagination}
        data={dataTable}
        onRowClick={handleRowClick}
        columnConfig={filterField}
        deleteIcon
        handleDrawerDelete={handleDeleteStep}
      />
    </>
  );
};

export default BannersTable;
